import classNames from "classnames";
import ons from "onsenui";
import React from "react";
import { getCSSIOSSuffix } from "../utils/DeviceUtils";
import { BackButton } from "./BackButton";
import { IsDefined } from "./Generic/IsDefined";
import { ScreenSkeleton, TitleBarStyle } from "./ScreenSkeleton";

interface Props {
  title: JSX.Element | string;
  titleBarStyle: TitleBarStyle;
  actionButton?: JSX.Element;
  onBackClick?: () => void;
}

const ScreenSkeletonHeader = ({ title, titleBarStyle, actionButton, onBackClick }: Props) => {
  return (
    <>
      <IsDefined value={onBackClick}>
        {(_onBackClick) => (
          <BackButton
            isBlack={titleBarStyle === ScreenSkeleton.TitleBarStyle.TRANSPARENT}
            onClick={_onBackClick}
          />
        )}
      </IsDefined>
      <div
        className={classNames("ScreenSkeleton__headerSkeletonFixedHeight ScreenSkeleton__header", {
          [`ScreenSkeleton__headerSkeletonFixedHeight_iOS${getCSSIOSSuffix()}`]:
            ons.platform.isIOS(),
          ScreenSkeleton__headerSecondary: titleBarStyle === ScreenSkeleton.TitleBarStyle.SECONDARY,
          ScreenSkeleton__headerPrimary: titleBarStyle !== ScreenSkeleton.TitleBarStyle.SECONDARY,
        })}
      >
        <div className="ScreenSkeleton__headerTitle">
          <div className="ScreenSkeleton__headerTitleText">{title}</div>
        </div>
        {actionButton !== undefined ? (
          <div className={"ScreenSkeleton__actionButton"}>{actionButton}</div>
        ) : null}
      </div>
    </>
  );
};

export default React.memo(ScreenSkeletonHeader);
